import { render, staticRenderFns } from "./VLeftRight.vue?vue&type=template&id=e11721a8&"
import script from "./VLeftRight.vue?vue&type=script&lang=ts&"
export * from "./VLeftRight.vue?vue&type=script&lang=ts&"
import style0 from "./VLeftRight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports